// extracted by mini-css-extract-plugin
module.exports = {"wave2DetailH":"H_wave2DetailH__W2Cco"};